<template>
    <div class="common-header">
        <div class="breadcrumb">
            <!--一般的标题显示-->
            <div class="baseInfo-left-base d-s-c">
                <img v-if="baseInfo.shop_logo" :src="baseInfo.shop_logo" class="sidebar-logo">
                <span class="name">{{ baseInfo.shop_name }}</span>
                <div class="el-tabs-container">
                    <span>当前考区：内蒙古</span>
                </div>
            </div>

            <div class="header-navbar">
                <div class="header-navbar-icon">
                    <span>当前版本：{{baseInfo.version}}</span>
                </div>
                <div class="header-navbar-icon" @click="messageFunc()">
                    <span class="ml4"><Icon class="svg-icon" :iconname="'#icon-geren9'"></Icon></span>
                    <span class="ml4">{{ baseInfo.user.nickName }}，欢迎您！ </span>
                    <el-badge :value="msgCount" class="item" v-if="msgCount != 0"></el-badge>
                </div>
                <div class="header-navbar-icon"><span class="gray">|</span></div>
                <div class="header-navbar-icon" @click="passwordFunc()"><span>修改密码</span></div>
                <div class="header-navbar-icon login-out" @click="login_out()">
                    <span class="ml4"><Icon :iconname="'#icon-tuichu'"></Icon></span>
                    <span class="ml4">退出</span>
                </div>
            </div>
        </div>

        <!--修改密码-->
        <UpdatePassword v-if="is_password" @close="closeFunc"></UpdatePassword>

        <!--查看通知-->
        <Message v-if="is_message" @close="messageCloseFunc"></Message>
    </div>
</template>

<script>
    import bus from '@/utils/eventBus.js';
    import AuthApi from '@/api/auth.js';
    import UserApi from '@/api/user.js';
    import {setCookie, delCookie, getCookie, deleteSessionStorage} from '@/utils/base.js';
    import store from '@/store';
    import UpdatePassword from './part/UpdatePassword.vue';
    import Message from './part/Message.vue';

    export default {
        components: {
            UpdatePassword,
            Message
        },
        data() {
            return {
                /*菜单名称*/
                menu_title: '菜单',
                /*切换菜单*/
                tabList: [],
                /*切换选中*/
                activeValue: 0,
                /*是否修改密码*/
                is_password: false,
                // 是否查看通知
                is_message: false,
                /*tab切换类别*/
                tab_type: '',
                // 未读消息数量
                msgCount: 0
            };
        },
        inject: ['baseInfo'],
        created() {
            /*监听菜单传过来的值*/
            bus.$on('menuName', res => {
                this.menu_title = res;
            });

            /*监听传插件的值*/
            bus.$on('tabData', res => {
                this.tabList = res.list;
                this.activeValue = res.active;
                this.tab_type = res.tab_type;
            });

            //发送给其它组件头部加载完成
            bus.$emit('headLoad', true);

            // 未读消息数量
            this.getMessageCount()

        },
        beforeDestroy() {
            bus.$off('menuName');
            bus.$off('tabData');
        },
        mounted() {

        },
        methods: {
            // 退出登录
            login_out() {
                this.$confirm('此操作将退出登录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        UserApi.loginOut({}, true)
                            .then(data => {
                                // 删除登录状态
                                delCookie('isLogin_supplier');
                                // 删除token信息
                                delCookie('token_supplier');
                                // 删除基本信息
                                delCookie('baseInfo_supplier');
                                // 删除已选专业
                                delCookie('major_id');
                                // 删除用户菜单
                                deleteSessionStorage('rolelist_supplier');
                                // 删除用户权限
                                deleteSessionStorage('authlist_supplier');
                                // 返回登录页
                                this.$router.replace({path: '/login'});
                                // 删除stores数据
                                this.$store.commit('user/setState', {key: 'roles', val: null});
                                // 刷新页面
                                location.reload();
                            })
                            .catch(error => {

                            });
                    })
                    .catch(() => {
                        // this.$message({
                        //   type: 'info',
                        //   message: '已取消退出'
                        // });
                    });
            },

            // 修改密码
            passwordFunc() {
                this.is_password = true
            },
            // 关闭修改密码
            closeFunc() {
                this.is_password = false
            },

            // 消息列表
            getMessageCount() {
                let that = this;

                UserApi.messageCount(that.search,true)
                    .then(res => {
                        that.msgCount = res.data.count
                    })
                    .catch(error => {
                        that.loading = false;
                    });
            },
            // 查看消息
            messageFunc() {
                this.is_message = true
            },
            // 关闭消息
            messageCloseFunc() {
                this.is_message = false
                this.getMessageCount()
            },
        }
    };
</script>

<style lang="scss" scoped>
    .common-header{
        color: #fff;
        .breadcrumb{
            .baseInfo-left-base{
                padding-left: 20px;
                .name{
                    margin-left: 15px;
                    font-size: 19px;
                }
                .el-tabs-container{
                    font-weight: 500;
                    margin-left: 20px;
                    padding-left: 20px;
                    border-left: 1px solid #EEEEEE;
                }
                img {
                    display: inline-block;
                    width: 40px;
                    height: 40px;
                    border-radius: 40px;
                    margin: 7px 0;
                }
            }
        }
        .header-navbar{
            .header-navbar-icon{
                font-size: 14px;
                .ml4 {
                    margin-left: 10px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }
                .svg-icon{
                    width: 30px;
                    height: 30px;
                }
                .item{
                    left: -10px;
                    top: -5px;
                }
            }
        }

        .common-header .el-tabs__nav-wrap::after {
            display: none;
        }
        .common-header .el-tabs__header {
            margin-bottom: 0;
        }
    }
</style>





// WEBPACK FOOTER //
// src/views/layout/Head.vue